import { render } from "./PaginationView.vue?vue&type=template&id=099206af&scoped=true"
import script from "./PaginationView.vue?vue&type=script&lang=js"
export * from "./PaginationView.vue?vue&type=script&lang=js"

import "./PaginationView.vue?vue&type=style&index=0&id=099206af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099206af"]])

export default __exports__